import { Autocomplete, TextField, Typography, Chip } from '@mui/material';
import { GridFilterInputValueProps } from '@mui/x-data-grid';

import { useFetchAuthors } from '@/hooks/queries/evaluations';

const FilterAuthors = ({ item, applyValue }: GridFilterInputValueProps) => {
  const { data: authors = [], isLoading } = useFetchAuthors();

  const getSelectedValues = (): string[] => {
    if (!item.value) return [];
    if (Array.isArray(item.value)) return item.value;
    if (typeof item.value === 'string') {
      return item.value.split(',').filter(Boolean);
    }
    return [];
  };

  const handleChange = (_event: any, newValue: string[]) => {
    applyValue({ ...item, value: newValue });
  };

  return (
    <Autocomplete
      multiple
      value={getSelectedValues()}
      options={authors}
      loading={isLoading}
      onChange={handleChange}
      disableCloseOnSelect
      isOptionEqualToValue={(option, value) => option === value}
      getOptionLabel={(option) => option}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          size="small"
          label="Authors"
          placeholder="Select authors"
          sx={{ minWidth: 300, pr: '10px', mt: 0.3 }}
        />
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            label={option}
            size="small"
            {...getTagProps({ index })}
            key={option}
          />
        ))
      }
      renderOption={(props, option) => (
        <li {...props} key={option}>
          <Typography>{option}</Typography>
        </li>
      )}
    />
  );
};

export default FilterAuthors;
